import { HotelCalendarType } from "@website/accommodation-ui/hotel-calendar/hotel-calendar.type";
import { MaterialIcon } from "@website/icons/material";
import { Datepicker } from "@website/ui/datepicker";
import { deepCompare } from "@website/utils/deep-compare";
import { memo } from "react";

const Component = (properties: HotelCalendarType) => {
  const {
    calendarDate,
    onCalendarChange,
    calendarData,
    disableLimit,
    disableDates,
    showTitle = false,
    isLabelTop = false
  } = properties;

  return (
    <div>
      {showTitle && (
        <div className="text-subtitle-1 md:text-headline-6 pb-4">
          تقویم و نرخ قیمتی
        </div>
      )}
      <div
        className={`${
          isLabelTop ? "relative" : ""
        } border-outline-thin z-[5] rounded-lg border p-3 md:p-4`}
        id="hotel_calendar"
      >
        <Datepicker
          calendarData={calendarData}
          disableDates={disableDates}
          disableLimit={disableLimit}
          mode="range"
          onChange={onCalendarChange}
          type="flat"
          value={calendarDate}
          isLabelTop={isLabelTop}
        />
        <div className="border-outline-thin flex items-center gap-1 border-t pt-4">
          <MaterialIcon className="text-warning" name="bolt" />
          <span className="text-caption">
            در این رزروها بدون نیاز به تایید میزبان، آنی رزرو کنید.
          </span>
        </div>
      </div>
    </div>
  );
};

export const HotelCalendar = memo(Component, deepCompare);
